import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthUser from "../services/AuthUser";


// import "./MobileHeaderWithSidebar.css"; // Optional CSS file for styling





const MobileHeaderWithSidebar = ({ logoSrc = "assets/img/logo/header-logo10a.svg", logoAlt = "Logo" }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Initially false, sidebar is closed
  const [activeSubMenu, setActiveSubMenu] = useState(); // To track active submenu

  // Use AuthUser to get authentication details
  const { token, user, logout } = AuthUser();




  const isAgent = !!localStorage.getItem("agent_token"); // true if token exists
  const isUser = !!token; // Check if token exists


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen); // Toggle the sidebar state
  };

  const toggleSubMenu = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };



  let profileMenus = [];

  if (isAgent) {
    profileMenus.push({ title: "Agent Profile", link: "agentprofile" });
  } else if (isUser) {
    profileMenus.push({ title: "My Profile", link: "profile" });
  } else {
    profileMenus.push(

      { title: "Partners Login", link: "agent-login" },
      { title: "User Login", link: "login" },
    );
  }

  // Sample menu items
  const menuItems = [
    {
      title: "Start Business",
      subItems: [
        { title: "Partnership Deed", link: "partnershipdeed" },
        { title: "Pvt. Ltd. Company Registration", link: "pvtltdcompanyregistration" },
        { title: "Section 8 Company Registration", link: "section8companyregistration" },
        { title: "LLP Registration", link: "llpcompanyregistration" },
        { title: "Annual Compliance LLP", link: "annualcompliancellp" },
        { title: "Annual Compliance Pvt. Ltd.", link: "annualcompliancepvtltd" },
        { title: "OPC Company Registration", link: "opccompanyregistration" },
        { title: "CMA Report", link: "cmareport" },
      ],
    },
    {
      title: "Change in Business",
      subItems: [
        { title: "Dissolution of Deeds", link: "dissolution-of-deeds" },
        { title: "Address Amendment (LLP)", link: "address-amendment-llp" },
        { title: "Address Amendment (Company)", link: "address-amendment-company" },
        { title: "Address Amendment out of state (LLP)", link: "address-amendment-outofstate-llp" },
        { title: "Address Amendment out of state (Company)", link: "address-amendment-outofstate-company" },
        { title: "Add Director (Company)", link: "add-director" },
        { title: "Remove Director (Company)", link: "remove-director" },

        { title: "Add Partner (Company)", link: "add-partner" },
        { title: "Remove Partner (LLP)", link: "remove-partner" },
        { title: "Increase Capital (LLP)", link: "increase-capital-llp" },
        { title: "Increase Capital (Company)", link: "increase-capital-company" },
        { title: "Change In Name (LLP)", link: "change-name-llp" },
        { title: "Change In Name (Company)", link: "change-name-company" },
      
      ],
    },
    {
      title: "Registrations",
      subItems: [
        { title: "Import Export License (IEC)", link: "importexportlicenseiec" },
        { title: "MSME Registration", link: "msmeregistration" },
        { title: "Gumasta License", link: "gumastalicense" },
        { title: "Trade Mark Registration", link: "trademarkregistration" },
        { title: "GST Registration", link: "gstregistration" },
        { title: "Food Licence", link: "foodlicence" },
        { title: "Trust/Society Registration", link: "trust-and-society" },
        { title: "ESIC & PF Registration", link: "pf-and-esic" },
        { title: "Professional Tax Registration", link: "professionaltax" },
      ],
    },
    {
      title: "Filing and More",
      subItems: [
        { title: "Online Accounting", link: "onlineaccounting" },
        { title: "GST Return Filing", link: "gstreturnfiling" },
        { title: "ITR Filing", link: "itrfiling" },
        { title: "TDS Return Filing", link: "tdsreturnfiling" },
        { title: "PF & ESIC Return Filing ", link: "pf-esic-return" },
        { title: "Balance Sheet Preparation & P&L", link: "balancesheet" },
      ],
    },
    {
      title: "Legal Issues",
      subItems: [
        { title: "Legal Notice Reply", link: "legalnoticereply" },
        { title: "Legal Advice", link: "legalclaimhelp" },
        { title: "Legal Notice Preparation", link: "legalnotice" },
      ],
    },
    {
      title: "Drafting",
      link: "drafting",


    },
    {
      title: "About Company",
      link: "aboutcompany",


    },
    ...profileMenus,

  ];

  return (
    <div>
      {/* Mobile Header */}
      <div className="mobile-header mobile-header-4 d-lg-none">
        <div className="container-fluid">
          <div className="col-12">
            <div className="mobile-header-elements">
              <div className="mobile-logo">
                <Link to="/">
                  <img src={logoSrc} alt={logoAlt} />
                </Link>
              </div>

              {/* Mobile Navigation Icon */}
              <div className="mobile-nav-icon" onClick={toggleSidebar}>
                <i className="fa-solid fa-bars"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar */}
      {isSidebarOpen && (
        <div className={`mobile-sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <div className="menu-close" onClick={() => setIsSidebarOpen(false)}>
            {/* Close button */}
            <svg
              className="svg-inline--fa fa-xmark"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="xmark"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
              ></path>
            </svg>
          </div>

          {/* Navigation Links */}
          <div className="mobile-nav">
            <ul className="mobile-nav-list">
              {menuItems.map((item, index) => (
                <li key={index} className="has-sub hash-has-sub">
                  {item.subItems ? (
                    <>
                      <span
                        className={`submenu-button ${activeSubMenu === index ? "submenu-opened" : ""}`}
                        onClick={() => toggleSubMenu(index)}
                      ></span>

                      <a className="hash-nav">{item.title}</a>

                      <ul
                        className={`sub-menu ${activeSubMenu === index ? "submenu-visible" : ""}`}
                      >
                        {item.subItems.map((subItem, subIndex) => (
                          <li key={subIndex} className="hash-has-sub">
                            <Link
                              to={`/${subItem.link}`}
                              className="hash-nav"
                              onClick={() => setIsSidebarOpen(false)} // Close the sidebar on link click
                            >
                              {subItem.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <Link
                      to={`/${item.link}`}
                      className="hash-nav"
                      onClick={() => setIsSidebarOpen(false)} // Close the sidebar on link click
                    >
                      {item.title}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileHeaderWithSidebar;
